var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandadoAbierto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    "data-name": "Grupo 443",
    transform: "translate(-1592 -1298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_72",
    "data-name": "Rect\\xE1ngulo 72",
    width: 26,
    height: 26,
    transform: "translate(1592 1298)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lock_open_right_FILL0_wght300_GRAD0_opsz40",
    d: "M181.445-863.157H192.4a.276.276,0,0,0,.2-.08.277.277,0,0,0,.08-.2v-9.044a.276.276,0,0,0-.08-.2.276.276,0,0,0-.2-.08H181.445a.276.276,0,0,0-.2.08.276.276,0,0,0-.08.2v9.044a.277.277,0,0,0,.08.2A.276.276,0,0,0,181.445-863.157Zm5.482-3.225a1.528,1.528,0,0,0,1.117-.458,1.5,1.5,0,0,0,.462-1.1,1.564,1.564,0,0,0-.464-1.116,1.5,1.5,0,0,0-1.119-.484,1.487,1.487,0,0,0-1.117.484,1.578,1.578,0,0,0-.462,1.124,1.485,1.485,0,0,0,.464,1.1A1.538,1.538,0,0,0,186.927-866.382Zm-5.766,3.225v0Zm.284,1.16a1.39,1.39,0,0,1-1.018-.425,1.389,1.389,0,0,1-.425-1.018v-9.044a1.387,1.387,0,0,1,.425-1.021,1.393,1.393,0,0,1,1.018-.423h7.2v-2.027a3.9,3.9,0,0,1,1.18-2.862,3.9,3.9,0,0,1,2.862-1.18,3.866,3.866,0,0,1,2.642.974,3.963,3.963,0,0,1,1.34,2.4.542.542,0,0,1-.121.453.5.5,0,0,1-.4.211.66.66,0,0,1-.409-.123.575.575,0,0,1-.208-.374,2.86,2.86,0,0,0-.973-1.7,2.759,2.759,0,0,0-1.868-.687,2.779,2.779,0,0,0-2.041.841,2.779,2.779,0,0,0-.84,2.041v2.027h2.6a1.393,1.393,0,0,1,1.018.423,1.387,1.387,0,0,1,.425,1.021v9.044a1.389,1.389,0,0,1-.425,1.018A1.389,1.389,0,0,1,192.4-862Z",
    transform: "translate(1416.996 2181.996)",
    fill: "#e7e7e7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandadoAbierto);
export default __webpack_public_path__ + "static/media/candado-abierto.b974d4a58bb249749daf80ace4a18e3b.svg";
export { ForwardRef as ReactComponent };